import React from "react";
import { useTranslation } from "react-i18next";
import { PMDialog } from "../../../utils/PMDialog";

/**
 * Chooser for nested calculation creation from the line editor.
 * - New: blank nested OfferCalculation (reusable sub-scope)
 * - Existing: pick firm template → copy as nested (does not mutate the template)
 */
export default function CalculationNestedSourceDialog({
  open,
  onClose,
  onChooseNew,
  onChooseExisting,
  busy = false,
}) {
  const { t } = useTranslation();

  return (
    <PMDialog
      open={Boolean(open)}
      onClose={() => {
        if (!busy) onClose?.();
      }}
      size="md"
      title={t("offer.calculation.nested_source.title")}
    >
      <p className="mb-4 text-sm text-slate-600">
        {t("offer.calculation.nested_source.hint")}
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        <button
          type="button"
          disabled={busy}
          className="rounded-xl border border-slate-200 bg-white px-4 py-4 text-left shadow-sm transition hover:border-[#1463C7] hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
          onClick={() => onChooseNew?.()}
        >
          <strong className="block text-sm font-semibold text-slate-900">
            {t("offer.calculation.nested_source.new_title")}
          </strong>
          <span className="mt-1 block text-sm text-slate-500">
            {t("offer.calculation.nested_source.new_hint")}
          </span>
        </button>
        <button
          type="button"
          disabled={busy}
          className="rounded-xl border border-slate-200 bg-white px-4 py-4 text-left shadow-sm transition hover:border-[#1463C7] hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
          onClick={() => onChooseExisting?.()}
        >
          <strong className="block text-sm font-semibold text-slate-900">
            {t("offer.calculation.nested_source.existing_title")}
          </strong>
          <span className="mt-1 block text-sm text-slate-500">
            {t("offer.calculation.nested_source.existing_hint")}
          </span>
        </button>
      </div>
      <div className="mt-5 flex justify-end">
        <button
          type="button"
          className="inline-flex justify-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 disabled:opacity-60"
          onClick={() => onClose?.()}
          disabled={busy}
        >
          {t("offer.calculation.nested_source.cancel")}
        </button>
      </div>
    </PMDialog>
  );
}
